export const formatPriceWithSpaces = (
    price: number,
    decimalSeparator = '.',
): string => {
    if (isNaN(price)) {
        throw new Error(
            '[cs/lib/ts/numbers.ts#formatPriceWithSpaces] Invalid number',
        );
    }

    return price
        .toLocaleString('fr-FR', {
            useGrouping: true,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
        .replace(/,/g, decimalSeparator);
};

const FRACTION = 1024 as const;

// Convert KB to bytes (1 KB = 1024 bytes)
export const KBtoBytes = (kb: number) => kb * FRACTION;
// Convert MB to bytes (1 MB = 1024 KB)
export const MBtoBytes = (mb: number) => KBtoBytes(mb * FRACTION);
// Convert bytes to KB (1 KB = 1024 bytes)
export const bytesToKB = (bytes: number) => bytes / FRACTION;
// Convert bytes to MB (1 MB = 1024 KB)
export const bytesToMB = (bytes: number) => bytesToKB(bytes) / FRACTION;

// Convert 50000 -> 500 | NaN -> null | 0 -> 0
export const normalizePaymentAmount = (amount: number | null) => {
    if (typeof amount === 'number' && !isNaN(amount)) {
        return amount / 100;
    }

    return null;
};
